export default "__VITE_ASSET__Bvqc1fpz__"